export const animations = {
  growDuration: 300,
  zoomDuration: 200,
  slideDuration: 500,
};

export default animations;
